import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { FileDownloadOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";
import moment from "moment";

import { useLazyLateShipmentListQuery } from "store/services/reportApi";
import { exportExcelFile } from "utils/exportExcelFile";
import { useAuth } from "hooks";

const EXPORT_LIMIT = 10000;

const ExportLateShipmentExcel = ({
  lateShipment,
  destinationBranch = [],
  sourceBranch = [],
  status,
  deliveryTypes,
  keyword,
}) => {
  const { isVendor, isCustomer } = useAuth();
  const [fetchShipments, { isLoading, isFetching }] =
    useLazyLateShipmentListQuery();

  const handleDownload = async () => {
    try {
      const responseData = await fetchShipments({
        page: 1,
        limit: EXPORT_LIMIT,
        ...(keyword && { keyword }),
        ...(deliveryTypes && { types: deliveryTypes }),
        ...(destinationBranch.length > 0 && { destinationBranch }),
        ...(sourceBranch.length > 0 && { sourceBranch }),
        ...(status && { status }),
        lateShipment,
        ...(!status && { excludeDelivered: true }),
      }).unwrap();

      if (!responseData?.data || responseData.data.length === 0) {
        toast.info("No late shipment records found for the current filters.");
        return;
      }

      const formattedData = responseData.data.map((row, index) => ({
        SN: index + 1,
        "Shipment ID": row.shipmentId || "N/A",
        Sender:
          !isVendor && !isCustomer
            ? row?.customerUser?.name
              ? `CUS: ${row.customerUser.name}`
              : row?.vendor?.shopName
                ? `VEN: ${row.vendor.shopName}`
                : "N/A"
            : "N/A",
        Receiver: row?.receiver?.customerUser?.name || "N/A",
        "Receiver Phone": row?.receiver?.phone || "N/A",
        "Source Branch": row?.sourceBranch?.name || "N/A",
        "Destination Branch": row?.destinationBranch?.name || "N/A",
        "Duration (days)": Math.floor(row.totalDays || 0),
        "Shipment Status": row.status || "N/A",
      }));

      exportExcelFile({
        sheetData: formattedData,
        fileName: `Late_Shipment_Report_${moment().format("YYYYMMDD")}`,
      });

      if (responseData.totalItems > formattedData.length) {
        toast.info(
          `Downloaded ${formattedData.length} of ${responseData.totalItems} records. Some records were not included due to the maximum export limit.`
        );
      } else {
        toast.success("Data downloaded successfully");
      }
    } catch (error) {
      console.error("Error fetching late shipment data:", error);
      toast.error("Error fetching late shipment data: " + error.message);
    }
  };

  return (
    <Tooltip title="Export Excel" arrow>
      <IconButton
        color="success"
        onClick={handleDownload}
        disabled={isLoading || isFetching}
      >
        <FileDownloadOutlined />
      </IconButton>
    </Tooltip>
  );
};

export default ExportLateShipmentExcel;
